import { apiFetch } from '../utils/api';

export interface InventoryRow {
  id: string;
  erpId: number;
  productVariantErpId: number;
  locationErpId: number;
  stock: string;
  productVariant?: { id: string; erpId: number; name: string } | null;
  location?: { id: string; erpId: number; name: string } | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedInventoriesResponse {
  data: InventoryRow[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const fetchInventories = (params: {
  page?: number;
  limit?: number;
  variantErpId?: number;
  locationErpId?: number;
  locationId?: string;
  search?: string;
} = {}): Promise<PaginatedInventoriesResponse> => {
  const searchParams = new URLSearchParams();
  if (params.page) searchParams.set('page', String(params.page));
  if (params.limit) searchParams.set('limit', String(params.limit));
  if (params.variantErpId) searchParams.set('variantErpId', String(params.variantErpId));
  if (params.locationErpId) searchParams.set('locationErpId', String(params.locationErpId));
  if (params.locationId) searchParams.set('locationId', params.locationId);
  if (params.search) searchParams.set('search', params.search);
  const query = searchParams.toString();
  return apiFetch<PaginatedInventoriesResponse>(`/inventories${query ? `?${query}` : ''}`);
};
